import { EarningMechanismExternalFulfillmentFragment } from '@occc/graphql';

import { awardHelper } from './awardHelper';

import { AwardType } from '../types';

export const getExternalFulfillmentAwardType = (
  earningMechanism: EarningMechanismExternalFulfillmentFragment,
): AwardType => {
  if (!earningMechanism.externalFulfillmentAward) {
    return AwardType.AwardNullable;
  }

  return awardHelper.isPointsAward(earningMechanism.externalFulfillmentAward)
    ? AwardType.AwardPoints
    : AwardType.AwardVouchers;
};
